import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';

import { RootState } from 'src/app/store';
import { formatDateAsTodayOrMonthDay } from 'src/common/date/formatDateAsTodayOrMonthDay';
import { FormErrorMessage } from 'src/common/FormErrorMessage';

export function AssignmentEmptyState() {
  const selectedDate = useSelector(
    (state: RootState) => state.dispatcher.selectedDate
  );

  return (
    <FormErrorMessage>
      No assignments are found for {formatDateAsTodayOrMonthDay(selectedDate)}
      .&nbsp;
      <NavLink to="/team" className="underline hover:opacity-80">
        Add a new assignment
      </NavLink>
    </FormErrorMessage>
  );
}
